// @flow
import React, { Component } from 'react'
import moment from 'moment'
import { StyledContent, StyledList, NotesMonth } from './style'
import { Calendar, Badge } from 'antd'

class CalendarView extends Component<{}> {

  // return date data
  getListData(value: moment): Object[] {

    let listData: Object[] | typeof(undefined)

    switch (value.date()) {
      case 8: {
        listData = [
          { type: 'warning', content: 'Warning Item.' },
          { type: 'success', content: 'Success Item.' }
        ]
        break
      }
      case 10: {
        listData = [
          { type: 'warning', content: 'Warning Item.' },
          { type: 'success', content: 'Success Item.' },
          { type: 'error', content: 'Error Item.' }
        ]
        break
      }
      case 15: {
        listData = [
          { type: 'warning', content: 'Warning Item.' },
          { type: 'success', content: 'Success Item.' },
          { type: 'error', content: 'Error Item.' }
        ]
        break
      }
      default:
    }
    return listData || []
  }

  // return month data
  getMonthData(value: moment): number | typeof(undefined) {

    if (value.month() === 8) return 1394
  }

  // filter changes
  onPanelChange(value: moment, mode: string) {
    console.log(value, mode)
  }

  render() {

    // generates cells for day view
    const dateCellRender = (value: moment): StyledList => {

      const listData: Object[] = this.getListData(value)

      return (
        <StyledList>
          {
            listData.map((item: Object) => (
              <li key={item.content}>
                <Badge status={item.type} text={item.content} />
              </li>
            ))
          }
        </StyledList>
      )
    }

    // generates cells for month view
    const monthCellRender = (value: moment): NotesMonth | null => {

      const num: number | typeof(undefined) = this.getMonthData(value)

      return num ? (
        <NotesMonth>
          <section>{num}</section>
          <span>Backlog number</span>
        </NotesMonth>
      ) : null
    }

    return (
      <StyledContent>
        <Calendar
          dateCellRender={dateCellRender}
          monthCellRender={monthCellRender}
          onPanelChange={this.onPanelChange} />
      </StyledContent>
    )
  }
}

export default CalendarView



// WEBPACK FOOTER //
// ./src/components/view-calendar/index.js